import Plausible from "plausible-tracker";

export default class ConcealmentAnalytics {
  private static plausible: ReturnType<typeof Plausible> | null = null;

  static getPlausible() {
    if (ConcealmentAnalytics.plausible === null) {
      const plausible = Plausible({
        domain: 'concealmentvpn.com',
        apiHost: 'https://straw.tryonhaulcentral.com',
        trackLocalhost: false,
      })
      plausible.enableAutoPageviews()
      plausible.enableAutoOutboundTracking()

      ConcealmentAnalytics.plausible = plausible
    }

    return ConcealmentAnalytics.plausible
  }
}

